import { API_URL } from '../../Config/Config';
import { apiGet, apiPatch, apiPost } from '../standardApi';

export async function apiGetMembers() {
  const response = await apiGet(`/Members`, 'application/json');
  return response;
}
export async function apiSendCodeByEmail(memberId) {
  const response = await apiPost(
    `/Members/SendCodeByEmail`,
    JSON.stringify({}),
    'text/plain'
  );
  return response;
}
export async function apiUpdatePhone(memberId, code, phone) {
  const response = await apiPatch(
    `/Members/UpdatePhone/${memberId}/${code}`,
    JSON.stringify({
      phone
    }),
    'application/json'
  );
  return response;
}
export async function apiUpdateAddress(memberId, code, body) {
  const response = await apiPatch(
    `/Members/UpdateAddress/${memberId}/${code}`,
    body,
    '',
    'form-data'
  );
  return response;
}
export async function apiUpdateEmail(memberId, code, email) {
  const response = await apiPatch(
    `/Users/UpdateEmail/${memberId}/${code}`,
    JSON.stringify({
      email
    }),
    'application/json'
  );
  return response;
}
export async function apiVerifyLogin(email, password) {
  return apiPost(
    '/Auth/VerifyLogin',
    JSON.stringify({
      emailOrMemberNumber: email,
      password: password
    }),
    'application/json',
    'application/json'
  );
}

export async function SendProofOfAddress(memberId, code, attachement) {
  const response = await apiPatch(
    `/Members/SendProofOfAddress/${memberId}/${code}`,
    attachement,
    'application/json',
    'form-data'
  );
  return response;
}

export const sendEmailOtp = async (email) => {
  return apiPost(
    '/AccountDeletion/SendMailOtp',
    JSON.stringify({
      email: email
    }),
    'application/json'
  );
};

export async function apiGetPostalAddressOnly(adress) {
  const response = await apiGet(
    `/PostalAddress/PostalAddressOnly?address=${adress}`,
    'application/json'
  );
  return response;
}

export async function apiGetMembersLogin(memberId, token) {
  try {
    const response = await fetch(API_URL + `/Members/${memberId}`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
        Authorization: 'Bearer ' + token
      }
    });
    const JsonData = await response.json();
    return { ...JsonData, status: response.status };
  } catch (err) {
    return { status: 500 };
  }
}

export async function apiGetProfil(token) {
  try {
    const response = await fetch(API_URL + `/Members`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
        Authorization: 'Bearer ' + token
      }
    });
    const JsonData = await response.json();
    return { ...JsonData, status: response.status };
  } catch (err) {
    return { status: 500 };
  }
}

export async function apiCreateBeneficiary(contractId, body) {
  const response = await apiPost(
    `/Members/CreateBeneficiary/${contractId}`,
    body,
    '',
    'form-data'
  );
  return response;
}

export async function deleteAccount(otpCode, email) {
  return apiPost(
    '/AccountDeletion/DeleteAccount',
    JSON.stringify({
      otpCode,
      email
    }),
    'application/json'
  );
}
export async function apiDeleteBeneficiary(contractId, body) {
  const response = await apiPost(
    `/Members/CancelBeneficiary`,
    body,
    '',
    'form-data'
  );
  return response;
}
